var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('md-tabs',[_c('md-tab',{attrs:{"id":"tab-home","md-label":"Home"}}),_c('md-tab',{attrs:{"id":"tab-pages","md-label":"Pages"}}),_c('md-tab',{attrs:{"id":"tab-posts","md-label":"Posts"}}),_c('md-tab',{attrs:{"id":"tab-favorites","md-label":"Favorites"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }